import * as types from '@/store/types'

export default {	
    [types.MUTATE_CONVOYS]: (state, payload) => {
        state.convoys = payload;
    },            
    [types.MUTATE_PARTICIPANTS]: (state, payload) => {
        state.participants = payload;
    },
    [types.MUTATE_VEHICLES]: (state, payload) => {
        state.vehicles = payload;
    },
    [types.MUTATE_TRUCKS]: (state, payload) => {
        state.trucks = payload;
    },
    [types.MUTATE_PHOTOS]: (state, payload) => {
        state.photos = payload;
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/land_movement/mutations.js